import { switchProps as defaultSwitchProps } from '../../pages/profile/config/config';

export const switchProps = {
    ...defaultSwitchProps,
    height: 20,
    width: 34,
    handleDiameter: 14
};
